import {
  isActionTypeDisplay,
  isElementTypeContainer,
} from '@/common/converter/utils/element'

/**
 * elementList 의 action type 이 display 인
 * element 의 execute url 을 반환한다.
 * @param elementList
 * @returns {*|string}
 */
export const getExecuteUrl = (elementList = []) => {
  const element = elementList?.find(isElementTypeContainer) ?? {}
  const action = element?.actionList?.find(isActionTypeDisplay) ?? {}

  return action?.execute?.data?.url ?? ''
}
